import React from 'react'
import { filterBlockByType } from '../../../services/common'
import { icon } from '../../../services/icon'

const WhereToContactExternalLink = ({ block }) => {
    const blockwebResource = filterBlockByType(block?.childrens || block, 'RessourceWeb')
    const blockTitle = filterBlockByType(block?.childrens || block, 'Titre')

    return (
        <a
            target="_blank"
            rel="noopener noreferrer"
            title={`${blockTitle?.content} - ${blockwebResource?.attributes?.URL} - Nouvelle fenêtre`}
            href={blockwebResource?.attributes?.URL}
            className="baseocom-where-to-contact-external-link"
        >
            <p>{blockTitle.content}</p>
            {icon('external-link')}
        </a>
    )
}

export default WhereToContactExternalLink
